import Trigger from '../../validations/es6/plugins/Trigger';
import Bootstrap from '../../validations/es6/plugins/Bootstrap';
import Excluded from '../../validations/es6/plugins/Excluded';

const opt = {
    fields: {
        brandColor: {
            validators: {
                notEmpty: {
                    message: 'Primary color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        sidebarColor: {
            validators: {
                notEmpty: {
                    message: 'Sidebar color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        infoColor: {
            validators: {
                notEmpty: {
                    message: 'Info color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        successColor: {
            validators: {
                notEmpty: {
                    message: 'Success color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        warningColor: {
            validators: {
                notEmpty: {
                    message: 'Warning color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        dangerColor: {
            validators: {
                notEmpty: {
                    message: 'Danger color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        scooterColor: {
            validators: {
                notEmpty: {
                    message: 'Scooter color is required'
                },
                regexp: {
                    regexp: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: 'Please enter a valid hex colorvalue like #AABBCC'
                },
            },
        },
        companyName: {
            validators: {
                notEmpty: {
                    message: 'Company name is required'
                },
            },
        },
        companyWebsite: {
            validators: {
                notEmpty: {
                    message: 'Company website is required'
                },
            },
            uri: {
                message: 'Please enter a valid URL (including http/https)'
            },
        },
        fontFamily: {
            validators: {
                notEmpty: {
                    message: 'Font family is required'
                },
            },
        },
        privacyPolicyUrl: {
            validators: {
                notEmpty: {
                    message: 'Privacy policy URL is required'
                },
                uri: {
                    message: 'Please enter a valid URL (including http/https)'
                },
            },
        },
        cookiePolicyUrl: {
            validators: {
                notEmpty: {
                    message: 'Cookie policy URL is required'
                },
                uri: {
                    message: 'Please enter a valid URL (including http/https)'
                },
            },
        },
        termsAndConditionsUrl: {
            validators: {
                notEmpty: {
                    message: 'Terms and Conditions URL is required'
                },
                uri: {
                    message: 'Please enter a valid URL (including http/https)'
                },
            },
        },
    },
    plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap(),
        excluded: new Excluded(),
    },
};

export {opt};